import React from "react";
import { SvgContainer } from "./style";
const Index = props => {
  return (
    <SvgContainer
      id="svgContent"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      color={props.color}
      size={props.size}
    >
      <g>
        <path d="M58 17h-2v-2a3.999 3.999 0 0 0-4-4h-6V8a3 3 0 0 0-6 0v3h-8V8a3 3 0 0 0-6 0v3h-8V8a3 3 0 0 0-6 0v3H6a3.999 3.999 0 0 0-4 4v34a3.999 3.999 0 0 0 4 4h2v2a4.004 4.004 0 0 0 4 4h46a4.004 4.004 0 0 0 4-4V21a4.004 4.004 0 0 0-4-4Zm-45 6a3 3 0 0 1 0-6h32a3 3 0 0 1 0 6Zm27 13a11.007 11.007 0 0 1-11 11c-14.594-.598-14.59-21.405 0-22a11.007 11.007 0 0 1 11 11Zm2 3a2.006 2.006 0 0 1 2-2h6a2.006 2.006 0 0 1 2 2v4a2.006 2.006 0 0 1-2 2h-6a2.006 2.006 0 0 1-2-2Zm8-5h-6a2.006 2.006 0 0 1-2-2v-4a2.006 2.006 0 0 1 2-2h6a2.006 2.006 0 0 1 2 2v4a2.006 2.006 0 0 1-2 2ZM8 26h6a2.006 2.006 0 0 1 2 2v4a2.006 2.006 0 0 1-2 2H8a2.006 2.006 0 0 1-2-2v-4a2.006 2.006 0 0 1 2-2ZM6 39a2.006 2.006 0 0 1 2-2h6a2.006 2.006 0 0 1 2 2v4a2.006 2.006 0 0 1-2 2H8a2.006 2.006 0 0 1-2-2ZM42 8a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0ZM28 8a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0ZM14 8a1 1 0 0 1 2 0v4a1 1 0 0 1-2 0Zm46 47a2.003 2.003 0 0 1-2 2H12a2.003 2.003 0 0 1-2-2v-2h42a3.999 3.999 0 0 0 4-4V19h2a2.003 2.003 0 0 1 2 2Z" />
        <path d="M20 36a9.014 9.014 0 0 0 9 9c11.941-.504 11.938-17.498 0-18a9.014 9.014 0 0 0-9 9Zm10-7v1h2a1 1 0 0 1 0 2h-3.5a1.5 1.5 0 0 0 0 3h1a3.5 3.5 0 0 1 .5 6.96V43a1 1 0 0 1-2 0v-1h-2a1 1 0 0 1 0-2h3.5a1.5 1.5 0 0 0 0-3h-1a3.5 3.5 0 0 1-.5-6.96V29a1 1 0 0 1 2 0Z" />
      </g>
    </SvgContainer>
  );
};

export default Index;
